module.exports = __webpack_public_path__ + "img/active_04.0850dc92.jpg";